import { render, staticRenderFns } from "./RulesTable.vue?vue&type=template&id=d9a0be84&scoped=true"
import script from "./RulesTable.vue?vue&type=script&lang=ts"
export * from "./RulesTable.vue?vue&type=script&lang=ts"
import style0 from "./RulesTable.vue?vue&type=style&index=0&id=d9a0be84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9a0be84",
  null
  
)

export default component.exports